import React, { useEffect , useState} from 'react';
import { connect } from 'react-redux';
import { nextStep, dropFiles } from '../redux/actions/actions';
import Dropzone from "react-dropzone";
import { SingleFloorplanInfoDiv }from './constants/infoConstants';

const SingleUploadPlan = (props) => {
    const [showUserinfoDiv, setShowUserinfoDiv] = useState(false);

    const handleDrop = (files) => {        
        files.sort(function(imga, imgb){
            if(imga.path < imgb.path) { return -1; }
            if(imga.path > imgb.path) { return 1; }
            return 0;
        })
        props.dropFiles(files, "PLAN");
        props.nextStep("upload files", props.prev_step);
    }
    const Cancel = () => {
        props.nextStep("plan library", props.prev_step)
    }

    useEffect(() => {
        if(props.setShowTools)
            props.setShowTools(false);
    }, [])

    return (<>
        <h1 className='userHelpCircle' style={{marginTop: '3%'}}  onClick={() => setShowUserinfoDiv(!showUserinfoDiv)}>?</h1>
        <div className="uploadPlans" style={{width:'600px'}}>
            <Dropzone onDrop={handleDrop}>
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: "dropzone" })}>
                        <h3>Drop floor plans here</h3><br/>
                        <h3>Or</h3><br/>
                        <input {...getInputProps()} />
                        <button>Choose file</button><br/>
                        {/* <h3>Single file upload</h3> */}
                    </div>

                )}
            </Dropzone>
            <div className="cancelBtnBlue"><button onClick={Cancel}>Cancel</button></div>
            
            {showUserinfoDiv ? <SingleFloorplanInfoDiv /> : ''}
        </div></>
    );
}

const putState = (state) => {
    return {
        step: state.step,
        prev_step: state.prev_step
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        dropFiles: (files, title) => dispatch(dropFiles(files, title))
    }
}

export default connect(putState, putActions) (SingleUploadPlan);